import DistributorService from '../services/distributor.service'

export const distributorModule = {
  namespaced: true,

  state: {
    distributors: [],
    distributor: null
  },

  actions: {
    async search ({ commit }) {
      return DistributorService.search().then(
        response => {
          const distributors = response.data
          commit('searchSuccess', distributors)
          return Promise.resolve(distributors)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async update ({ commit }, criterias) {
      return DistributorService.update(criterias).then(
        response => {
          const responseData = response.data
          return Promise.resolve(responseData)
        },
        error => {
          return Promise.reject(error.response)
        }
      )
    },

    async detail ({ commit }, criterias) {
      return DistributorService.detail(criterias).then(
        response => {
          const detail = response.data
          return Promise.resolve(detail)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async setDistributor ({ commit }, distributor) {
      commit('distributorSuccess', distributor)
    },

    async reset ({ commit }) {
      commit('listReset')
    }
  },

  mutations: {
    searchSuccess (state, distributors) {
      state.distributors = distributors
    },
    searchFailure (state) {
      state.distributors = []
    },
    listReset (state) {
      state.distributors = []
    },
    distributorSuccess (state, distributor) {
      state.distributor = distributor
    }
  }
}
